// extracted by mini-css-extract-plugin
export default {"accountHeader":"Er-z","primeBadge":"Fr-z","logout":"Gr-z"};